import actionsTypes from './actionTypes';
import { ILoadDataSuccessPayload } from './types';
import { LoadMetabaseRequestAction, LoadMetabaseSuccessAction, LoadMetabaseErrorAction } from './actions.d';

const actions = {
  loadMetabaseRequest: (): LoadMetabaseRequestAction => ({
    type: actionsTypes.LOAD_METABASE_REQUEST,
  }),

  loadMetabaseSuccess: (payload: ILoadDataSuccessPayload): LoadMetabaseSuccessAction => ({
    type: actionsTypes.LOAD_METABASE_SUCCESS,
    payload,
  }),

  loadMetabaseError: (): LoadMetabaseErrorAction => ({
    type: actionsTypes.LOAD_METABASE_ERROR,
  }),
};

export default actions;
